function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 30587"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1857",
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    style: {
      fill: "transparent"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Exclusion 3",
    d: "M20 40a20.005 20.005 0 0 1-7.785-38.428 20.005 20.005 0 0 1 15.57 36.856A19.877 19.877 0 0 1 20 40zM8.122 27.461a13.8 13.8 0 0 0 7.478 2.185 14.03 14.03 0 0 0 5.942-1.259 13.1 13.1 0 0 0 4.342-3.253 14.33 14.33 0 0 0 3.569-9.34c0-.208 0-.422-.015-.634a10.386 10.386 0 0 0 2.443-2.517 9.748 9.748 0 0 1-2.8.754 4.847 4.847 0 0 0 2.141-2.684 9.654 9.654 0 0 1-3.091 1.176A4.873 4.873 0 0 0 19.7 15.22a5.548 5.548 0 0 0 .121 1.116 13.876 13.876 0 0 1-10.042-5.095 4.875 4.875 0 0 0 1.507 6.512 4.909 4.909 0 0 1-2.2-.618v.06a4.87 4.87 0 0 0 3.9 4.779 5.192 5.192 0 0 1-1.282.166 6 6 0 0 1-.92-.076 4.88 4.88 0 0 0 4.553 3.377A9.708 9.708 0 0 1 9.3 27.52a10.016 10.016 0 0 1-1.178-.059z",
    style: {
      fill: "#1d9cf0"
    }
  })));
};

export default SvgTwitter;